import { createFileRoute } from '@tanstack/react-router';
import { Route as giveaway_index_route } from '@routes/giveaways/$programId/index';
import { AdPage } from '@src/components/layout/AdPage';
import { GiveawayRowSmall } from '@src/components/giveaway/GiveawayRowSmall';
import { useViewTransition } from '@src/hooks/useViewTransition';

export const Route = createFileRoute('/giveaways/$programId/ad')({
  staticData: {
    title: 'Ad',
  },
  component: function Component() {
    const giveaway = Route.parentRoute.useLoaderData();
    const _navigate = Route.useNavigate();
    const { showAccountAndBalance, showHeader } = Route.useSearch();

    const { slideLeftFullPage } = useViewTransition();

    const navigate = () => {
      _navigate({
        to: giveaway_index_route.to,
        params: {
          programId: giveaway?.programId,
        },
        search: {
          giveawayId: giveaway?.giveawayId,
          showHeader: showHeader,
          showAccountAndBalance: showAccountAndBalance,
        },
        viewTransition: slideLeftFullPage,
      });
    };

    if (!giveaway?.sponsor) {
      navigate();
      return undefined;
    }

    return (
      <AdPage
        sponsor={giveaway.sponsor}
        navigate={navigate}
        giveawayId={giveaway.giveawayId}
        smallRow={<GiveawayRowSmall giveaway={giveaway} />}
      />
    );
  },
});
